{
  "familyId": "TAA-WOORD-SYNONIEM",
  "questions": [
    {
      "id": "TAA-WOORD-SYNONIEM-001",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Welk woord is een synoniem van 'blij'?",
      "context": null,
      "options": ["Vrolijk", "Verdrietig", "Boos", "Bang"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen",
            "content": "Een synoniem is een woord met (bijna) dezelfde betekenis. 'Blij' en 'vrolijk' betekenen allebei dat je een goed gevoel hebt.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.81,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.antonym-as-synonym", "label": "Verwart antoniem met synoniem", "optionIndex": 1 },
          { "id": "taa.related-word-as-synonym", "label": "Verwart verwant woord met synoniem", "optionIndex": 2 },
          { "id": "taa.related-word-as-synonym", "label": "Verwart verwant woord met synoniem", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een synoniem is een woord met dezelfde of bijna dezelfde betekenis. 'Blij' = een goed, gelukkig gevoel. 'Vrolijk' = een goed, opgewekt gevoel. Ze betekenen bijna hetzelfde → synoniem.",
        "solutionSteps": [
          "'Blij' = een goed, gelukkig gevoel",
          "'Vrolijk' = een goed, opgewekt gevoel",
          "Bijna dezelfde betekenis → synoniem"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vrolijk' is een synoniem van 'blij' — beide betekenen een goed gevoel.",
          "1": "Je dacht waarschijnlijk dat 'verdrietig' een synoniem is. Maar 'verdrietig' is het tegenovergestelde (antoniem) van 'blij'. Onthoud: synoniem = zelfde betekenis, antoniem = tegenovergestelde.",
          "2": "Je dacht waarschijnlijk dat 'boos' een synoniem is. Maar 'boos' is een ander gevoel (woede), niet hetzelfde als 'blij'. Onthoud: synoniemen hebben dezelfde betekenis.",
          "3": "Je dacht waarschijnlijk dat 'bang' een synoniem is. Maar 'bang' is een ander gevoel (angst), niet hetzelfde als 'blij'. Onthoud: synoniemen hebben dezelfde of bijna dezelfde betekenis."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-002",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "matching",
      "question": "Koppel elk woord aan zijn synoniem.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Groot", "Snel", "Mooi", "Slim"],
        "rightItems": ["Knap", "Vlug", "Fors", "Intelligent"],
        "correctMatches": {"0": 2, "1": 1, "2": 0, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen koppelen",
            "content": "Groot = fors (allebei 'van grote omvang'). Snel = vlug (allebei 'met hoge snelheid'). Mooi = knap (allebei 'aantrekkelijk'). Slim = intelligent (allebei 'verstandig').",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_matching",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Groot ↔ Fors (grote omvang). Snel ↔ Vlug (hoge snelheid). Mooi ↔ Knap (aantrekkelijk). Slim ↔ Intelligent (verstandig).",
        "solutionSteps": [
          "Groot ↔ Fors (grote omvang)",
          "Snel ↔ Vlug (hoge snelheid)",
          "Mooi ↔ Knap (aantrekkelijk)",
          "Slim ↔ Intelligent (verstandig)"
        ]
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-003",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN synoniem van 'koud'?",
      "context": null,
      "options": ["Warm", "Fris", "IJzig", "Kil"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniem of niet?",
            "content": "Synoniemen hebben dezelfde betekenis. 'Fris', 'ijzig' en 'kil' betekenen allemaal iets van koude. 'Warm' is het tegenovergestelde (antoniem).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_vs_antonym",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.near-synonym-not-synonym", "label": "Denkt dat bijna-synoniem geen synoniem is", "optionIndex": 1 },
          { "id": "taa.strong-synonym-not-synonym", "label": "Denkt dat sterk synoniem geen synoniem is", "optionIndex": 2 },
          { "id": "taa.near-synonym-not-synonym", "label": "Denkt dat bijna-synoniem geen synoniem is", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Zoek het woord dat NIET dezelfde betekenis heeft. Fris = een beetje koud ✓. IJzig = heel erg koud ✓. Kil = onaangenaam koud ✓. Warm = het tegenovergestelde van koud ✗. 'Warm' is geen synoniem maar een antoniem.",
        "solutionSteps": [
          "Fris = een beetje koud ✓ (synoniem)",
          "IJzig = heel erg koud ✓ (synoniem)",
          "Kil = onaangenaam koud ✓ (synoniem)",
          "Warm = tegenovergestelde ✗ (antoniem)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Warm' is het tegenovergestelde (antoniem) van 'koud', geen synoniem.",
          "1": "Je dacht waarschijnlijk dat 'fris' geen synoniem is. Maar 'fris' betekent een beetje koud — het is wél een synoniem. Onthoud: synoniemen hoeven niet precies hetzelfde te betekenen.",
          "2": "Je dacht waarschijnlijk dat 'ijzig' geen synoniem is. Maar 'ijzig' betekent heel erg koud — het is wél een synoniem. Onthoud: ook woorden met een sterkere betekenis kunnen synoniemen zijn.",
          "3": "Je dacht waarschijnlijk dat 'kil' geen synoniem is. Maar 'kil' betekent onaangenaam koud — het is wél een synoniem. Onthoud: synoniemen hebben dezelfde of bijna dezelfde betekenis."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-004",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Lees: 'De reiziger was uitgeput na de lange tocht.' Welk woord is een synoniem van 'uitgeput'?",
      "context": null,
      "options": ["Doodmoe", "Energiek", "Opgewekt", "Sterk"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniem uit context",
            "content": "Na een lange tocht is de reiziger heel erg moe. 'Uitgeput' = alle energie kwijt. 'Doodmoe' betekent hetzelfde: extreem moe.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_context",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.antonym-as-synonym", "label": "Verwart antoniem met synoniem", "optionIndex": 1 },
          { "id": "taa.antonym-as-synonym", "label": "Verwart antoniem met synoniem", "optionIndex": 2 },
          { "id": "taa.related-word-as-synonym", "label": "Verwart verwant woord met synoniem", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Gebruik de context om de betekenis te bepalen. Na een lange tocht → de reiziger is heel moe. 'Uitgeput' = alle energie kwijt. 'Doodmoe' = extreem moe → synoniem.",
        "solutionSteps": [
          "Context: na een lange tocht → heel moe",
          "'Uitgeput' = alle energie kwijt",
          "'Doodmoe' = extreem moe → synoniem"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Doodmoe' is een synoniem van 'uitgeput' — beide betekenen extreem moe.",
          "1": "Je dacht waarschijnlijk dat 'energiek' een synoniem is. Maar 'energiek' is het tegenovergestelde — vol energie, niet uitgeput. Onthoud: synoniem = zelfde betekenis.",
          "2": "Je dacht waarschijnlijk dat 'opgewekt' een synoniem is. Maar 'opgewekt' betekent vrolijk en levendig — het tegenovergestelde van uitgeput. Onthoud: kijk naar de context.",
          "3": "Je dacht waarschijnlijk dat 'sterk' een synoniem is. Maar 'sterk' gaat over kracht, niet over vermoeidheid. Onthoud: synoniemen hebben dezelfde betekenis."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-005",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "fill_in",
      "question": "Schrijf een synoniem van 'rennen'.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["hardlopen", "sprinten", "hollen", "draven", "spurten", "snellen"],
        "placeholder": "Typ een synoniem...",
        "caseSensitive": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen bedenken",
            "content": "Denk aan woorden die hetzelfde betekenen als 'rennen': hardlopen, sprinten, hollen, draven. Al deze woorden betekenen 'snel bewegen op je benen'.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_fill_in",
      "variantIndex": 5,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Synoniemen van 'rennen': hardlopen, sprinten, hollen, draven, spurten, snellen. Al deze woorden betekenen 'snel bewegen op je benen'.",
        "solutionSteps": [
          "'Rennen' = snel bewegen op je benen",
          "Synoniemen: hardlopen, sprinten, hollen, draven, spurten, snellen"
        ]
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-006",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "categorize",
      "question": "Sorteer de woordparen: zijn het synoniemen (zelfde betekenis) of antoniemen (tegenovergestelde)?",
      "data": {
        "categories": ["Synoniemen", "Antoniemen"],
        "items": [
          { "text": "blij – vrolijk", "correctCategory": 0 },
          { "text": "groot – klein", "correctCategory": 1 },
          { "text": "snel – vlug", "correctCategory": 0 },
          { "text": "warm – koud", "correctCategory": 1 },
          { "text": "slim – intelligent", "correctCategory": 0 },
          { "text": "licht – donker", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Synoniem of antoniem?", "content": "Synoniemen = zelfde betekenis (blij/vrolijk, snel/vlug, slim/intelligent). Antoniemen = tegenovergestelde betekenis (groot/klein, warm/koud, licht/donker).", "icon": "lightbulb" } }
      ],
      "conceptId": "synonym_vs_antonym_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Synoniemen hebben dezelfde betekenis: blij/vrolijk, snel/vlug, slim/intelligent. Antoniemen hebben de tegenovergestelde betekenis: groot/klein, warm/koud, licht/donker.",
        "solutionSteps": [
          "Vraag: betekenen de woorden hetzelfde? → synoniem",
          "Vraag: betekenen de woorden het tegenovergestelde? → antoniem",
          "Synoniemen: blij–vrolijk, snel–vlug, slim–intelligent",
          "Antoniemen: groot–klein, warm–koud, licht–donker"
        ]
      }
    }
  ]
}